import { workflowInstance } from '../instance';

interface ProfileData {
  id: string;
  attributes: {
    avatar: null | string;
  };
}

export type TFetchUserResponse = {
  data: {
    id: string;
    attributes: {
      email: string;
      name: string;
      firstName: string;
      lastName: string;
      autoGenerated: boolean;
    };
  };
  included: ProfileData[];
  meta: {
    autoLogin: boolean;
  };
};

export default {
  getUser: (): Promise<TFetchUserResponse> =>
    workflowInstance.get('v1/users/me?include=profile'),
};
